import React, { forwardRef, memo, useEffect, useRef } from 'react';
import { Moon, Sun, Headphones, ChevronRight } from 'lucide-react';
import { headerMarkup, footerMarkup } from './operationShellReference';

// Memoization is essential: a state update must never replace the map's DOM
// containers after React portals and event handlers have attached to them.
export const ReferenceDOM = memo(forwardRef(function ReferenceDOM({ markup }, ref) {
  return <div ref={ref} dangerouslySetInnerHTML={{ __html: markup }} />;
}));

export function OperationHeader() {
  const root = useRef(null);
  useEffect(() => {
    const el = root.current;
    const triggers = [...el.querySelectorAll('button[aria-controls$="mega-menu"]')];
    const close = () => {
      triggers.forEach(button => button.setAttribute('aria-expanded', 'false'));
      el.querySelectorAll('[data-mega-menu]').forEach(panel => { panel.dataset.open = 'false'; panel.inert = true; });
    };
    const open = button => {
      close();
      const panel = el.querySelector(`#${button.getAttribute('aria-controls')}`);
      if (panel) { panel.dataset.open = 'true'; panel.inert = false; button.setAttribute('aria-expanded', 'true'); }
    };
    const click = event => {
      const button = event.target.closest('button');
      if (triggers.includes(button)) {
        open(button);
      } else if (button?.getAttribute('aria-controls') === 'site-navigation') {
        const nav = el.querySelector('#site-navigation');
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        nav.dataset.mobileOpen = String(expanded);
      }
      if (event.target.closest('a')) close();
    };
    const over = event => {
      if (!window.matchMedia('(hover: hover)').matches) return;
      const button = event.target.closest('button');
      if (triggers.includes(button)) open(button);
    };
    const key = event => { if (event.key === 'Escape') { close(); el.querySelector('#site-navigation').dataset.mobileOpen = 'false'; } };
    const outside = event => { if (!el.contains(event.target)) close(); };
    el.addEventListener('click', click);
    el.addEventListener('mouseover', over);
    el.addEventListener('mouseleave', close);
    document.addEventListener('keydown', key);
    document.addEventListener('pointerdown', outside);
    return () => {
      el.removeEventListener('click', click); el.removeEventListener('mouseover', over);
      el.removeEventListener('mouseleave', close); document.removeEventListener('keydown', key); document.removeEventListener('pointerdown', outside);
    };
  }, []);
  return <ReferenceDOM ref={root} markup={headerMarkup} />;
}

export function OperationFooter() { return <ReferenceDOM markup={footerMarkup} />; }

export function OperationTheme({ theme, onChange }) {
  return <aside className="operation-theme" aria-label="Darstellung">
    <button aria-pressed={theme === 'dark'} onClick={() => onChange('dark')}><Moon size={21} /><span>Dunkel</span></button>
    <button aria-pressed={theme === 'light'} onClick={() => onChange('light')}><Sun size={21} /><span>Hell</span></button>
  </aside>;
}

export function OperationContact() {
  return <a className="operation-contact" href="/#kontakt"><Headphones size={29} /><span><small>24/7 Support</small><strong>Kontakt aufnehmen</strong></span><ChevronRight size={18} /></a>;
}
